<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-8"/>

    <!-- 작업 정보-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>신청인</div>
          <p v-if="isPrint" class="print-input">{{ form.신청인.name }}</p>
          <ml-input v-else v-model="form.신청인.name" class="w-full" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.신청인.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.신청인.sign" :src="form.신청인.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div />

        <div>
          <div>작업수행일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업수행일시 }}</p>
          <date-selector v-else v-model="form.작업수행일시" class="w-full" />
        </div>
        <div>
          <div>작업시간</div>
          <div class="flex">
            <p v-if="isPrint" class="print-input">{{ form.작업시간.start }}</p>
            <time-selector v-else v-model="form.작업시간.start" class="w-full" />
            <span class="mx-2">~</span>
            <p v-if="isPrint" class="print-input">{{ form.작업시간.end }}</p>
            <time-selector v-else v-model="form.작업시간.end" class="w-full" />
          </div>
        </div>
        <div />

        <div class="writeGridCol2">
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.작업장소 }}</p>
          <ml-input v-else v-model="form.작업장소" class="w-full" />
        </div>
        <div />

        <div class="writeGridCol2">
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.작업내용 }}</p>
          <ml-input v-else v-model="form.작업내용" class="w-full" />
        </div>
        <div />

        <div class="writeGridCol2">
          <div>출입자명단</div>
          <p v-if="isPrint" class="print-input">{{ form.출입자명단 }}</p>
          <ml-input v-else v-model="form.출입자명단" class="w-full" />
        </div>
        <div />

        <div>
          <div>작업관리감독자</div>
          <p v-if="isPrint" class="print-input">{{ form.작업관리감독자.name }}</p>
          <ml-input v-else v-model="form.작업관리감독자.name" class="w-full" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.작업관리감독자.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.작업관리감독자.sign" :src="form.작업관리감독자.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div />
      </div>
    </div>

    <!-- 작업방법-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 위 공간에서의 작업을 다음의 조건하에서만 허가함.</h5>
        </vs-col>
      </vs-row>
    </div>

    <div class="mt-4 flex gap-2">
      <div style="width: 300px; align-self: center;">1. 화기작업허가 필요유무</div>
      <radio-group
        class="col-span-4"
        flex
        :items="[
              { label: '필요', value: '필요' },
              { label: '불필요', value: '불필요' },
            ]"
        :row-count="2"
        v-model="form.화기필요유무"
      />
    </div>
    <div class="mt-4 flex gap-2">
      <div style="width: 300px; align-self: center;">2. 내연기관(양수기) 또는 갈탄 등의 사용여부</div>
      <radio-group
        class="col-span-4"
        flex
        :items="[
              { label: '사용', value: '사용' },
              { label: '미사용(양수기등 작업중 가능성도 검증)', value: '미사용' },
            ]"
        :row-count="2"
        v-model="form.내연기관사용여부"
      />
    </div>
    <div class="mt-4 flex gap-2">
      <div style="width: 300px; align-self: center;">3. 안전조치 요구사항</div>
    </div>
    <table-inspect-merge
      class="mt-4"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="false"
      v-model="form.inspectList"
      table-header-title="확인항목"
      :table-header-note="[{ text: '확인결과', width: '288' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '82' },
        { text: '미흡', value: 'No', width: '82' },
        { text: '해당없음', value: 'N/A', width: '82' },
      ]"
    />
    <div class="mt-4 flex justify-between w-full">
      <div style="width: 300px; align-self: center;">4. 산소 및 유해가스 농도 측정결과</div>
      <div v-if="!board.readonly && !isPrint">
        <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
      </div>
    </div>
    <table class="mt-4">
      <colgroup>
        <col width="60" />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <th style="padding: 0px;"><vs-checkbox :value="allCheck" @change="onClickAllCheckBox" /></th>
        <th>측정시간</th>
        <th colspan="4">물질명 / 기준 / 결과</th>
        <th>측정자</th>
        <th>감시인 확인</th>
      </thead>
      <tbody>
        <tr v-for="(item, i) in form.가스농도측정결과" :key="`table_${i}`">
          <td><vs-checkbox v-model="item.selected" /></td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.측정시간 }}</p>
            <time-selector v-else v-model="item.측정시간" class="w-full" />
          </td>
          <td>
            <p class="mb-2">산소(O2) : 18%~23.5%</p>
            <div class="flex gap-2">
              <p v-if="isPrint" class="print-input">{{ item.산소 }}</p>
              <ml-input v-else v-model="item.산소" class="w-full" />
              <span>%</span>
            </div>
          </td>
          <td>
            <p class="mb-2">탄산가스(CO2) : 1.5% ↓</p>
            <div class="flex gap-2">
              <p v-if="isPrint" class="print-input">{{ item.탄산가스 }}</p>
              <ml-input v-else v-model="item.탄산가스" class="w-full" />
              <span>%</span>
            </div>
          </td>
          <td>
            <p class="mb-2">일산화탄소(CO) :  30ppm ↓</p>
            <div class="flex gap-2">
              <p v-if="isPrint" class="print-input">{{ item.일산화탄소 }}</p>
              <ml-input v-else v-model="item.일산화탄소" class="w-full" />
              <span>ppm</span>
            </div>
          </td>
          <td>
            <p class="mb-2">황화수소(H2S) : 10ppm ↓</p>
            <div class="flex gap-2">
              <p v-if="isPrint" class="print-input">{{ item.황화수소 }}</p>
              <ml-input v-else v-model="item.황화수소" class="w-full" />
              <span>ppm</span>
            </div>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.측정자 }}</p>
            <ml-input v-else v-model="item.측정자" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.감시인 }}</p>
            <ml-input v-else v-model="item.감시인" class="w-full" />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mt-4 flex gap-2">
      <div style="width: 300px; align-self: center;">5. 특별조치 필요사항</div>
    </div>
    <div class="mt-4">
      <p v-if="isPrint" class="print-textarea">{{ form.특별조치 }}</p>
      <ml-textarea v-else v-model="form.특별조치" class="w-full" />
    </div>

    <!-- 확인자 -->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 확인자</h5>
      </vs-col>
    </vs-row>
    <name-with-signature-row label-name="담당" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />


    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "@/views/boards/single-page/1022/inspectData";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    TableInspectMerge,
    RadioGroup,
    SignField,
    NameWithSignatureRow,
    PrintCheckbox,
    TimeSelector,
    DateSelector,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],

        // 작업 정보
        신청인: { name: "", sign: "" },
        작업수행일시: "",
        작업시간: {
          start: "",
          end: "",
        },
        작업장소: "",
        작업내용: "",
        출입자명단: "",
        작업관리감독자: { name: "", sign: "" },

        화기필요유무: "",
        내연기관사용여부: "",
        inspectList: inspectData.inspectTable,
        가스농도측정결과: [],
        특별조치: "",
        sign1: { name: "", sign: "" },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.가스농도측정결과.push({ id: Math.random().toString(36).substr(2, 9)});
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.가스농도측정결과.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.가스농도측정결과 = this.form.가스농도측정결과.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.가스농도측정결과.forEach((row) => row.selected = true);
        } else {
          this.form.가스농도측정결과.forEach((row) => row.selected = false);
        }
      }, 100);
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.가스농도측정결과.filter((row) => row.selected).length === 0;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 14px;
      justify-items: center;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 400;
        color: #3c3c3c;
        line-height: 17px;
        padding: 6px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
